<template>
  <el-container :class="['container', isPhone ? 'container-phone' : '']">
    <el-aside
      v-if="!$route.meta.isHideMenu"
      :class="[
        'aside',
        $t('common.mode') === 'en' ? 'enWidth' : '',
        isCollapse ? 'iscollapse' : '',
      ]"
    >
      <el-row
        style="cursor: pointer; height: 60px"
        justify="center"
        @click="$router.push('/')"
      >
        <div class="logo-box" v-if="isCollapse">
          <img src="./logo.png" alt="" />
        </div>
        <div v-else class="logo-collapse">
          <img src="./logo.png" alt="" />
        </div>
      </el-row>
      <HMenu class="h-menu" :menus="menus" :iscollapse="isCollapse" />
      <el-tooltip
        class="collapse-tooltip"
        :content="isCollapse ? $t('common.expandMenu') : $t('common.shrinkMenu')"
        :placement="isCollapse ? 'bottom' : 'top'"
        effect="dark"
      >
        <img
          src="@/assets/images/collapse.png"
          class="collapse"
          @click="asideCollapse"
          alt=""
        />
      </el-tooltip>
    </el-aside>
    <el-main>
      <el-header v-if="!$route.meta.isHideMenu" style="height: 74px">
        <HHeader />
      </el-header>
      <section :class="$route.meta.isHideMenu ? 'full-screen' : 'content'">
        <HRouteView />
      </section>
    </el-main>
  </el-container>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { HMenu, HHeader, HRouteView } from "@/components";
import { getGlobalMenus } from "@/core/global-data";

const $route = useRoute();
const $router = useRouter();
const menus = getGlobalMenus().filter((item) => !item.hidden);
const isCollapse = ref(false);

const isPhone = ref(false);

onMounted(() => {
  isPhone.value = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
});

document.addEventListener("keydown", (event) => {
  // 输入框聚焦时，禁止监听x键
  if (
    document.activeElement.tagName !== "INPUT" &&
    document.activeElement.tagName !== "TEXTAREA"
  ) {
    if (event.key === "x") {
      isCollapse.value = !isCollapse.value;
    }
  }
});

function asideCollapse() {
  isCollapse.value = !isCollapse.value;
}
</script>
<style lang="scss" scoped>
$gradient-background: linear-gradient(
  86deg,
  #ff952b36 0%,
  var(--global-bg-color) 100%
);

.container {
  width: 100%;
  height: 100%;
  background: var(--el-blank-bg-color);
  position: relative;
  z-index: 0;
  overflow: hidden;

  .aside {
    width: 200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0;
    position: relative;
    overflow: hidden;
    background-color: var(--global-bg-color);
    transition: all 0.5s;
    @keyframes fadeIn {
      to {
        opacity: 1; /* 最终透明度为 1 */
      }
    }

    .logo-box {
      width: 100%;
      margin: 15px 0 15px 20px;
      font-size: 26px;
      color: #1f476e;
      line-height: 34px;
      opacity: 0; /* 初始透明度为 0 */
      animation: fadeIn 0.5s ease forwards; /* 动画持续 0.5s */
      animation-delay: 0.25s; /* 动画延迟 0.3s 后执行 */
      padding: 0 8px;

      > img {
        width: 100%;
      }

      &:active {
        opacity: 0.7;
      }

      > span {
        color: #0077ff;
      }
    }

    .logo-collapse {
      opacity: 0; /* 初始透明度为 0 */
      animation: fadeIn 0.5s ease forwards; /* 动画持续 0.5s */
      animation-delay: 0.25s; /* 动画延迟 0.3s 后执行 */
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 16px;
      color: #232835;
      padding: 0 12px;

      > img {
        width: 56%;
        position: relative;
        left: 28px;
        top: 10px;
      }
    }

    .h-menu {
      flex: 1;
      overflow: auto;
      border-right: none;
      margin-top: 10px;
      background-color: var(--global-bg-color);
      // min-width: 200px;
      :deep(.el-menu-item),
      :deep(.el-sub-menu) {
        position: relative;
        // height: 40px;
        color: #6b6f76;
        background-color: var(--global-bg-color);

        .icon-box {
          display: flex;
          width: 16px;
          height: 16px;
          margin-right: 10px;

          .icon {
            width: 16px;
            height: 16px;
            vertical-align: -0.15em;
            fill: currentColor;
            overflow: hidden;
          }
        }
      }

      :deep(.el-menu-item:hover) {
        // background: $gradient-background;
        color: var(--el-color-primary);
      }

      :deep(.el-menu-item) {
        height: 40px;
      }

      :deep(.el-sub-menu) {
        // height: 40px;
        .el-sub-menu__title {
          color: #6b6f76;
          height: 40px;
        }

        .el-sub-menu__title:hover {
          // background: $gradient-background;
          background-color: transparent;
          color: var(--el-color-primary);
        }

        .el-menu-item {
          padding-left: 46px;
        }
      }

      :deep(.el-menu-item.is-active) {
        color: var(--el-menu-text-active-color);
        background: $gradient-background;
      }

      :deep(.el-menu-item.is-active)::after {
        content: "";
        position: absolute;
        z-index: 99999;
        left: 0;
        top: 10px;
        width: 4px;
        height: 20px;
        border-radius: 0 3px 3px 0;
        background: var(--el-color-primary) !important;
      }

      :deep(.el-sub-menu.is-active) {
        .el-sub-menu__title {
          color: var(--el-menu-text-active-color);
        }

        .el-menu--inline {
          .is-active {
            color: var(--el-menu-text-active-color);
          }
        }
      }
    }
  }
  .enWidth {
    // width: 160px;
  }

  // menu收缩
  .aside.iscollapse {
    width: 60px;
    text-align: center;

    .logo-box {
      text-align: center;
      margin-left: 0;
      animation-delay: 0.1s; /* 动画延迟 0.3s 后执行 */
    }

    .h-menu {
      :deep(.el-menu-item),
      :deep(.el-sub-menu) {
        .el-menu-tooltip__trigger,
        .el-sub-menu__title {
          padding-left: 14px;
        }

        .icon-box {
          display: flex;
          width: 30px;
          height: 30px;
          margin-right: 10px;

          .icon {
            width: 30px;
            height: 30px;
            vertical-align: -0.15em;
            fill: currentColor;
            overflow: hidden;
          }
        }
      }
    }
  }

  .collapse,
  .expand {
    position: absolute;
    bottom: 56px;
    right: 22px;
    width: 24px;
    transition: transform 0.2s, box-shadow 0.2s, filter 0.2s;
    cursor: pointer;

    &:hover {
      filter: brightness(1.2);
      /* 鼠标移入时亮度增加 */
    }
  }

  .el-main {
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;

    .content {
      background: var(--global-bg-color);
      flex: 1;
      overflow-x: hidden;
      overflow-y: auto;
      padding: 10px 16px 10px 10px;
    }

    .full-screen {
      overflow: auto;
      flex: 1;
    }
  }

  .el-header {
    background-color: var(--global-bg-color);
    // box-shadow: 0px 4px 4px 0px rgba(78, 89, 105, 0.04);
    border: none;
    // margin-bottom: 1px;
    padding: 0;
  }
}

/*
媒体查询，当屏幕宽度小于1550px时，触发
*/
@media (max-width: 1550px) {
  .container {
    .aside {
      width: 160px;
    }
    .enWidth {
      width: 190px;
    }
  }
}
</style>
